import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Container, Columns, Column } from '@resurs/midas-react'
import { Redirect } from 'react-router'

import ProfileInfo from './ProfileInfo'
import { getCurrentUserStores } from '../../store/actions/store-info-actions'
import { editIncompleteUserProfile } from '../../store/actions/users-actions'
import { logout } from '../../store/actions/auth-actions'
import { getText } from '../../internal/TextLabels'

class EditProfile extends React.Component {
  componentDidMount() {
    this.props.getCurrentUserStores()
  }

  render() {
    const { auth, stores } = this.props
    if (!auth.isLoggedIn) {
      return <Redirect to="/login" />
    }
    return (
      <div>
        <Container grid960>
          <Columns>
            <Column col4 colMd2 colSm0 />
            <Column col4 colMd8 colSm12>
              <ProfileInfo
                me={auth.me}
                auth={auth}
                stores={stores}
                edit
                topSaveButton={false}
                onSave={updatedInfo => this.props.updateProfile(updatedInfo)}
              />
              <Button fullWidth type="link" onClick={() => this.props.logout()}>
                {getText('default.cancel')}
              </Button>
            </Column>
          </Columns>
        </Container>
      </div>
    )
  }
}

EditProfile.propTypes = {
  auth: PropTypes.object.isRequired,
  stores: PropTypes.array,
  getCurrentUserStores: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
}

EditProfile.defaultProps = {
  stores: [],
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    stores: state.storeInfo.stores,
  }
}

const mapDispatchToProps = dispatch => ({
  getCurrentUserStores: () => {
    dispatch(getCurrentUserStores())
  },
  updateProfile: user => {
    dispatch(editIncompleteUserProfile(user))
  },
  logout: () => {
    dispatch(logout())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile)
